import type { UserPrivate } from '@repo/types/users';
import type { ZustandHookSelectors } from 'auto-zustand-selectors-hook';

import { AccountType } from '@repo/types/enums/accountType';
import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { AuthStoreAction, AuthStoreState } from '.';

export const defaultCredentials: UserPrivate = {
  id: -1,
  name: '',
  surname: '',
  email: '',
  lvl: 0,
  accountType: AccountType.User,
  directoryId: '',
  phone: '',
  birthdate: '',
  avatarURL: null,
  active: true,
  last_login: '',
  authTokenExpiry: null,
  force_password_change: false,
  force_email_change: false,
  createdAt: '',
  updatedAt: '',
};

const useAuthStoreBase = create<AuthStoreAction & AuthStoreState>()(
  persist(
    (set) => ({
      credentials: defaultCredentials,
      setCredentials: (payload: UserPrivate) => set({ credentials: payload }),
      updateCredentials: (payload: Partial<UserPrivate>) =>
        set((state) => ({
          credentials: { ...state.credentials, ...payload },
        })),
      removeCredentials: () => {
        set({ credentials: defaultCredentials });
        useAuthStore.persist.clearStorage();
      },
    }),
    {
      name: 'credentials',
    }
  )
);

export const useAuthStore = createSelectorHooks(useAuthStoreBase) as typeof useAuthStoreBase & ZustandHookSelectors<AuthStoreAction & AuthStoreState>;

export const { useCredentials, useSetCredentials, useUpdateCredentials, useRemoveCredentials } = useAuthStore;
